module.exports = __webpack_public_path__ + "static/media/cartoon_01.0a3286ec.jpg";